import React, {
    useEffect
} from "react";
import { useParams, useSearchParams } from "react-router-dom";

import ProjectChoice from "./ProjectChoice";
import IDESelect from "./IDESelect";
import LevelSelect from "./LevelSelect";
import GameSelect from "./GameSelect";
import CreateProject from "./CreateProject";
import ProjectSelect from "./ProjectSelect";

import { useDataProvider } from "../../hooks/data/DataProvider";

const Projects = () => {

    const { labId } = useParams();

    const {
        games,
        loading,
        error,
        fetchGames
    } = useDataProvider();



    const [searchParams, setSearchParams] =
        useSearchParams();

    const step =
        searchParams.get("step") || "choice";

    const ideType =
        searchParams.get("ide");

    const level =
        searchParams.get("level");

    const gameId =
        searchParams.get("game");


    // ============================================================
    // TEMPORARY ACCESS DATA
    // Replace with actual backend/access data.
    // ============================================================

    const access = {
        id: Number(labId),
        advanced_ide_access: true
    };


    // ============================================================
    // NEW / OPEN PROJECT
    // ============================================================

    const handleProjectChoice = (choice) => {

        if (choice === "new") {

            setSearchParams({
                step: "ide"
            });

            return;
        }

        if (choice === "open") {

            setSearchParams({
                step: "projects"
            });

            return;
        }
    };


    // ============================================================
    // IDE SELECTION
    // ============================================================

    const handleIdeSelect = (ide) => {

        if (ide === "simple") {

            setSearchParams({
                step: "level",
                ide: "simple"
            });

            return;
        }


        if (ide === "advanced") {

            // Advanced IDE requires access.
            if (!access.advanced_ide_access) {
                return;
            }

            setSearchParams({
                step: "game",
                ide: "advanced"
            });

            return;
        }
    };


    // ============================================================
    // LEVEL SELECTION
    // ============================================================

    const handleLevelSelect = (selectedLevel) => {

        setSearchParams({
            step: "game",
            ide: "simple",
            level: selectedLevel
        });
    };


    // ============================================================
    // GAME SELECTION
    // ============================================================

    const handleGameSelect = (selectedGameId) => {

        setSearchParams({
            step: "create",
            ide: ideType,
            game: selectedGameId,
            ...(level
                ? { level }
                : {})
        });
    };


    // ============================================================
    // BACK
    // ============================================================

    const handleBack = () => {

        switch (step) {

            case "ide":

                setSearchParams({
                    step: "choice"
                });

                break;


            case "level":

                setSearchParams({
                    step: "ide"
                });

                break;


            case "game":

                if (ideType === "simple") {

                    setSearchParams({
                        step: "level",
                        ide: "simple"
                    });

                } else {

                    setSearchParams({
                        step: "ide"
                    });
                }

                break;


            case "create":

                setSearchParams({
                    step: "game",
                    ide: ideType,
                    ...(level
                        ? { level }
                        : {})
                });

                break;


            case "projects":

                setSearchParams({
                    step: "choice"
                });

                break;


            default:

                setSearchParams({});

        }
    };

    useEffect(() => {
        if (labId) {
            fetchGames(labId);
        }
    }, [labId]);


    // ============================================================
    // RENDER
    // ============================================================

    return (
        <div className="projects-page">

            {/* ====================================================
                NEW PROJECT / OPEN PROJECT
                ==================================================== */}

            {step === "choice" && (
                <ProjectChoice
                    onSelect={handleProjectChoice}
                />
            )}


            {/* ====================================================
                CHOOSE IDE
                ==================================================== */}

            {step === "ide" && (
                <IDESelect
                    advancedAccess={
                        access.advanced_ide_access
                    }
                    onSelect={handleIdeSelect}
                    onBack={handleBack}
                />
            )}


            {/* ====================================================
                CHOOSE LEVEL
                ==================================================== */}

            {step === "level" && (
                <LevelSelect
                    onSelect={handleLevelSelect}
                    onBack={handleBack}
                />
            )}


            {/* ====================================================
                CHOOSE GAME
                ==================================================== */}

            {step === "game" && (
                <GameSelect
                    games={games}
                    loading={loading}
                    error={error}
                    onSelect={handleGameSelect}
                    onBack={handleBack}
                />
            )}


            {/* ====================================================
                CREATE PROJECT
                ==================================================== */}

            {step === "create" && (
                <CreateProject
                    labId={labId}
                    gameId={gameId}
                    ideType={ideType}
                    level={level}
                    onBack={handleBack}
                />
            )}


            {/* ====================================================
                OPEN EXISTING PROJECT
                ==================================================== */}

            {step === "projects" && (
                <ProjectSelect
                    labId={labId}
                    onBack={handleBack}
                />
            )}

        </div>
    );
};

export default Projects;